import React from 'react';
import { List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import AvatarSmall from '../../common/AvatarSmall';
import User from './user';
import { replaceSpaceInName } from '../../../common/helperMethods';

export default (notification, index) => (
    <List.Item key={index}>
        <AvatarSmall id={notification.actor_id} name={notification.actor_name} />
        <List.Content>
            <List.Description>
                <User id={notification.actor_id} />{" "} added{' '}
                <Link to={`/company/${replaceSpaceInName(notification.exhibitor_name)}/${notification.exhibitor_id}`}>{notification.exhibitor_name}</Link> as an exhibitor to event{' '}
                <Link to={`/events/${replaceSpaceInName(notification.event_name)}/${notification.event_id}`}>{notification.event_name}</Link>
            </List.Description>
        </List.Content>
    </List.Item>
);
